// extracted by mini-css-extract-plugin
module.exports = {"Component":"Company_Component__1U65K","Content":"Company_Content__3RLxv"};